import { render, staticRenderFns } from "./s_EnterPhone.vue?vue&type=template&id=210f3627&"
import script from "./s_EnterPhone.vue?vue&type=script&lang=js&"
export * from "./s_EnterPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports